import axios from 'axios';
import { apiClient } from './axiosSettings'
import getAuthHeaders, { getCustomPanelAuthHeaders } from  './getAuthHeaders'

type textType = {
  id: string,
  text: string,
  sender: string,
  doNotTranslate?: boolean
}

type reqDataType = {
  endpoint: string,
  contactId?: string,
  body: {
    "sourceLanguage": string,
    "targetLanguage": string,
    "texts": textType[]
  }
}

export async function getTranslationData(reqData: any) {
  return apiClient.post(`${reqData.endpoint}/api/translate/chat`, reqData.body, { headers: getAuthHeaders() });
}

export const getTranslationFromGenAI = (
  reqData: reqDataType
) => {
  const url = `${reqData.endpoint}/conversation/translate?targetLanguage=${reqData.body.targetLanguage}${reqData.body.sourceLanguage ? `&inputLanguage=${reqData.body.sourceLanguage}` : ''}${reqData.contactId ? `&ContentId=${reqData.contactId}` : ''}`;
  const bodyTranscript = reqData.body.texts?.map(({ sender, text, id, doNotTranslate }) => ({
    message: text,
    sender,
    id,
    doNotTranslate
  }));
  return apiClient.post(url, { transcript: bodyTranscript }, { headers: getCustomPanelAuthHeaders() });
}

export const getTranslationForPDC = (translateURL: string, source: string = 'en', target: string = 'es', texts: Array<any>) => {
  return axios.post(translateURL,
    {
      "sourceLanguage": source, "targetLanguage": target, "texts": texts
    },
    {
      headers: getAuthHeaders(),
    }
  )
}